import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var TextExtraction =
/*#__PURE__*/
function () {
  /**
   * @param {String} text - Text to be parsed
   * @param {Object[]} patterns - Patterns to be used when parsed
   *                              other options than pattern would be added to the parsed content
   * @param {RegExp} patterns[].pattern - RegExp to be used for parsing
   */
  function TextExtraction(text, patterns) {
    _classCallCheck(this, TextExtraction);

    this.text = text;
    this.patterns = patterns || [];
  }
  /**
   * Returns parts of the text with their own props
   * @return {Object[]} - props for all the parts of the text
   */


  _createClass(TextExtraction, [{
    key: "parse",
    value: function parse() {
      var _this = this;

      var parsedTexts = [{
        children: this.text
      }];
      this.patterns.forEach(function (pattern) {
        var newParts = [];
        parsedTexts.forEach(function (parsedText) {
          // Only allow for now one parsing
          if (parsedText._matched) {
            newParts.push(parsedText);
            return;
          }

          var parts = [];
          var textLeft = parsedText.children;
          var indexOfMatchedString = 0;

          while (textLeft) {
            var matches = pattern.pattern.exec(textLeft);

            if (!matches) {
              break;
            }

            var previousText = textLeft.substr(0, matches.index);
            indexOfMatchedString += matches.index;
            parts.push({
              children: previousText
            });
            parts.push(_this.getMatchedPart(pattern, matches[0], matches, indexOfMatchedString));
            textLeft = textLeft.substr(matches.index + matches[0].length);
            indexOfMatchedString += matches[0].length;
          }

          parts.push({
            children: textLeft
          });
          newParts.push.apply(newParts, parts);
        });
        parsedTexts = newParts;
      }); // Remove _matched key.

      parsedTexts.forEach(function (parsedText) {
        return delete parsedText._matched;
      });
      return parsedTexts.filter(function (t) {
        return !!t.children;
      });
    } // private

    /**
     * @param {Object} matchedPattern - pattern configuration of the pattern used to match the text
     * @param {RegExp} matchedPattern.pattern - pattern used to match the text
     * @param {String} text - Text matching the pattern
     * @param {String[]} matches - Result of the RegExp.exec
     * @param {Integer} index - Index of the matched string in the whole string
     * @return {Object} props for the matched text
     */

  }, {
    key: "getMatchedPart",
    value: function getMatchedPart(matchedPattern, text, matches, index) {
      var props = {};
      Object.keys(matchedPattern).forEach(function (key) {
        if (key === 'pattern' || key === 'renderText') {
          return;
        }

        if (typeof matchedPattern[key] === 'function') {
          props[key] = function () {
            return matchedPattern[key](text, index);
          };
        } else {
          props[key] = matchedPattern[key];
        }
      });
      var children = text;

      if (matchedPattern.renderText && typeof matchedPattern.renderText === 'function') {
        children = matchedPattern.renderText(text, matches);
      }

      return _objectSpread({}, props, {
        children: children,
        _matched: true
      });
    }
  }]);

  return TextExtraction;
}();

export default TextExtraction;